import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

/**
 * IconSpaceOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3BhY2Utb2ZmIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDEwdjNhMSAxIDAgMCAwIDEgMWg5bTQgMGgxYTEgMSAwIDAgMCAxIC0xdi0zIiAvPgogIDxwYXRoIGQ9Ik0zIDNsMTggMTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/space-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSpaceOff = createReactComponent('outline', 'space-off', 'SpaceOff', __iconNode);

export default IconSpaceOff;